import { RadioGroup, FormControlLabel, Radio, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ChartDisplayType } from "glue/Chart/chart.constants";

type Props = {
  current: ChartDisplayType;
  onChange: (type: ChartDisplayType) => void;
  excludeArea?: boolean;
};

export function ChartTypeSwitch(props: Props) {
  const { t } = useTranslation();

  const chartOptions = [
    {
      value: ChartDisplayType.EMISSIONS,
      label: t("pageheader.emissions", "Emissions"),
      unit: props.excludeArea ? "kg CO2e" : "kg CO2e / m²",
    },
    {
      value: ChartDisplayType.ENERGY,
      label: t("pageheader.energy", "Energy"),
      unit: props.excludeArea ? "kWh" : "kWh / m²",
    },
  ];

  return (
    <RadioGroup
      row
      value={props.current}
      onChange={(e) => props.onChange(e.target.value as ChartDisplayType)}
    >
      {chartOptions.map((option) => (
        <FormControlLabel
          key={option.value}
          control={<Radio />}
          value={option.value}
          label={
            <Typography display="inline">
              {option.label}
              <Typography
                component="span"
                color="grey.500"
                display="inline"
                pl={1}
              >
                ({option.unit})
              </Typography>
            </Typography>
          }
        />
      ))}
    </RadioGroup>
  );
}
